import Vue from "vue";
import Router from "vue-router";
import notFound from "../views/notFound";
import enrollInfo from "../views/enrollInfo";
import enrollDetail from "../views/enrollDetail";

import main from "../views/main";

import router_main from "./router_main";
import router_public from "./router_public";

Vue.use(Router);

const router = new Router({
  mode: "history",
  routes: [
    {
      path: "/",
      component: main,
      redirect: "/home",
      children: [router_main, router_public]
    },
    {
      path: "/enroll_info",
      component: enrollInfo
    },
    {
      path: "/enroll_detail",
      component: enrollDetail
    },
    {
      path: "*",
      component: notFound
    }
  ]
});

router.beforeEach(async (to, from, next) => {
  console.log(location, "location");
  if (location.href) {
    if (location.href.includes("concact_us")) {
      console.log("fafsafs2222");
      document.title = "浙江华博特教育_联系方式_联系地址_报名电话";
    } else if (["enroll_info", "enroll_detail"].includes(location.href)) {
      document.title = "录取查询";
    } else {
      document.title = "华博特教育集团官网";
    }
  }

  next();
});

export default router;
